import DeviceAddPage from './device-add-page';

export default DeviceAddPage;